/** ========================================================================= *\
 * @prefab FarBackground
 * ========================================================================== */
import * as CONST from 'config';

class FarBackground extends Phaser.Group {

  /** Background Definitions ------------------------------------------------ */
  static Backgrounds = [
    // { from: 0, to: 20, key: 'beach-bg' },
    // { from: 20, to: 40, key: 'desert-bg' },
    // { from: 40, to: 60, key: 'winter-bg' },
    // { from: 60, to: 80, key: 'desolated-bg' },
    { from: 80, to: 100, key: 'city-bg2' }
  ];

  /** Class Properties ------------------------------------------------------ */
  game = undefined;
  backgroundSprites;
  isGameOver = false;

  /** @constructor ---------------------------------------------------------- */
  constructor(game, yPos) {
    super(game);
    this.game = game;

    // Instantiate sprites
    this.backgroundSprites = FarBackground.Backgrounds.map((background, i) => {
      const sprite = new Phaser.Sprite(game, 0, yPos, background.key);
      sprite.meta = background;
      sprite.anchor.set(0, 1);
      sprite.visible = false;
      sprite.alpha = 0;
      sprite.fixedToCamera = true;

      // Scale to viewport width
      let scaleFactor = (this.game.width / sprite.width) * (1.1 + (i * 0.05));
      scaleFactor = Math.max(scaleFactor, 0.75);
      sprite.width = sprite.width * scaleFactor;
      sprite.height = sprite.height * scaleFactor;

      this.add(sprite);
      return sprite;
    });

    // Show the first background sprite
    this.backgroundSprites[0].alpha = 1;
    this.backgroundSprites[0].visible = true;

    // Listen for game over event
    this.game.onEnd.add(() => this.isGameOver = true);
  }

  /** Methods --------------------------------------------------------------- */

  /** @main update loop */
  update() {
    // If the sprite is visible, offset it every frame to give a parallax effect
    // this.backgroundSprites.forEach((sprite) => {
    //   const threshold = (this.game.world.width - this.game.width) / this.game.world.width;
    //   if (sprite.visible && (this.game.progress - this.game.gameSpeedUp) < threshold && !this.isGameOver) {
    //     sprite.x -= 0.2 + ((this.game.progress - this.game.gameSpeedUp) * 0.1);
    //   }
    // });
    
    // // Transition between scenes
    // this.backgroundSprites.forEach((sprite, index) => {
    //   const isWithinBounds =
    //     (this.game.progress - this.game.gameSpeedUp) >= sprite.meta.from &&
    //     (this.game.progress - this.game.gameSpeedUp) <= sprite.meta.to;

    //   if (isWithinBounds && sprite.visible === false) {
    //     this.transitionIn(index);
    //   } else if (!isWithinBounds && sprite.visible === true && !sprite.isTransitioning) {
    //     this.transitionOut(index);
    //   }
    // });
  }

  /**
   * Transition in a background sprite
   * @param {Number} index
   */
  transitionIn(index) {
    const background = this.backgroundSprites[index];
    background.visible = true;

    // Tween background position
    const tweenFromY = background.y + background.height;
    const tween = this.game.add
      .tween(background.cameraOffset)
      .from({ y: tweenFromY }, 2000, Phaser.Easing.Quartic.Out, true)

    // Fade in background
    const fade = this.game.add
      .tween(background)
      .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true)
  }
  
  /**
   * Transition out a background sprite
   * @param {Number} index
   */
  transitionOut(index) {
    const background = this.backgroundSprites[index];
    background.isTransitioning = true;

    // Tween background position
    const tweenToY = background.y + background.height;
    const posTween = this.game.add
      .tween(background.cameraOffset)
      .to({ y: tweenToY }, 1000, Phaser.Easing.Quartic.InOut, true)

    // Fade out background
    const fadeTween = this.game.add
      .tween(background)
      .to({ alpha: 0 }, 500, Phaser.Easing.Linear.None, true)

    // Hide background when fade is finished
    fadeTween.onComplete.add(() => background.visible = false);
  }

}

export default FarBackground;



// WEBPACK FOOTER //
// ./js/prefabs/farBackground.js